module.exports = __webpack_public_path__ + "static/footer-logos-bottom-fdf8f513b24905c33c6005d05534cf21.svg";